import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { CanDeactivateGuard } from "../core/route-guards/can-deactivate-guard";
import { UserListComponent } from "./user-list/user-list.component";

const routes: Routes = [
  {
    path: "",
    children: [
      {
        path: "",
        component: UserListComponent,
      }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UsersRoutingModule {}
